export default {
  v: '5.7.8',
  fr: 30,
  ip: 0,
  op: 30,
  w: 50,
  h: 131,
  nm: 'scroll.pdf Comp 1',
  ddd: 0,
  assets: [],
  layers: [{
    ddd: 0,
    ind: 1,
    ty: 4,
    nm: 'Rectangle 1803 Outlines',
    parent: 2,
    sr: 1,
    ks: {
      o: { a: 0, k: 100, ix: 11 },
      r: { a: 0, k: 0, ix: 10 },
      p: {
        a: 0, k: [9, 10.5, 0], ix: 2, l: 2,
      },
      a: {
        a: 0, k: [3, 3, 0], ix: 1, l: 2,
      },
      s: {
        a: 0, k: [100, 100, 100], ix: 6, l: 2,
      },
    },
    ao: 0,
    shapes: [{
      ty: 'gr',
      it: [{
        ind: 0,
        ty: 'sh',
        ix: 1,
        ks: {
          a: 0,
          k: {
            i: [[0, 1.657], [-1.657, 0], [0, -1.657], [1.657, 0]], o: [[0, -1.657], [1.657, 0], [0, 1.657], [-1.657, 0]], v: [[-3, 0], [0, -3], [3, 0], [0, 3]], c: true,
          },
          ix: 2,
        },
        nm: 'Path 1',
        mn: 'ADBE Vector Shape - Group',
        hd: false,
      }, {
        ty: 'fl', c: { a: 0, k: [1, 1, 1, 1], ix: 4 }, o: { a: 0, k: 100, ix: 5 }, r: 1, bm: 0, nm: 'Fill 1', mn: 'ADBE Vector Graphic - Fill', hd: false,
      }, {
        ty: 'tr', p: { a: 0, k: [3, 3], ix: 2 }, a: { a: 0, k: [0, 0], ix: 1 }, s: { a: 0, k: [100, 100], ix: 3 }, r: { a: 0, k: 0, ix: 6 }, o: { a: 0, k: 100, ix: 7 }, sk: { a: 0, k: 0, ix: 4 }, sa: { a: 0, k: 0, ix: 5 }, nm: 'Transform',
      }],
      nm: 'Group 1',
      np: 2,
      cix: 2,
      bm: 0,
      ix: 1,
      mn: 'ADBE Vector Group',
      hd: false,
    }],
    ip: 0,
    op: 30,
    st: 0,
    bm: 0,
  }, {
    ddd: 0,
    ind: 2,
    ty: 3,
    nm: 'scroll Outlines 3',
    parent: 4,
    sr: 1,
    ks: {
      o: { a: 0, k: 100, ix: 11 },
      r: { a: 0, k: 0, ix: 10 },
      p: {
        a: 1,
        k: [{
          i: { x: 0.667, y: 1 }, o: { x: 0.333, y: 0 }, t: 2, s: [9, 11, 0], to: [0, 0.833, 0], ti: [0, 0, 0],
        }, {
          i: { x: 0.145, y: 1 }, o: { x: 0.42, y: 0 }, t: 10, s: [9, 16, 0], to: [0, 0, 0], ti: [0, 0.833, 0],
        }, {
          i: { x: 0.833, y: 0.833 }, o: { x: 0.333, y: 0.333 }, t: 22, s: [9, 11, 0], to: [0, 0, 0], ti: [0, 0, 0],
        }, {
          i: { x: 0.667, y: 1 }, o: { x: 0.333, y: 0 }, t: 252, s: [9, 11, 0], to: [0, 0.833, 0], ti: [0, 0, 0],
        }, {
          i: { x: 0.667, y: 1 }, o: { x: 0.333, y: 0 }, t: 257, s: [9, 16, 0], to: [0, 0, 0], ti: [0, 0.833, 0],
        }, { t: 265, s: [9, 11, 0] }],
        ix: 2,
        l: 2,
      },
      a: {
        a: 0, k: [9, 11, 0], ix: 1, l: 2,
      },
      s: {
        a: 0, k: [100, 100, 100], ix: 6, l: 2,
      },
    },
    ao: 0,
    ip: 0,
    op: 30,
    st: 2,
    bm: 0,
  }, {
    ddd: 0,
    ind: 3,
    ty: 4,
    nm: 'Shape Layer 1',
    parent: 4,
    sr: 1,
    ks: {
      o: { a: 0, k: 100, ix: 11 },
      r: { a: 0, k: 0, ix: 10 },
      p: {
        a: 0, k: [9, 12.875, 0], ix: 2, l: 2,
      },
      a: {
        a: 0, k: [0, 0, 0], ix: 1, l: 2,
      },
      s: {
        a: 0, k: [50, 50, 100], ix: 6, l: 2,
      },
    },
    ao: 0,
    shapes: [{
      ty: 'rc', d: 1, s: { a: 0, k: [32, 48], ix: 2 }, p: { a: 0, k: [0, 0], ix: 3 }, r: { a: 0, k: 22, ix: 4 }, nm: 'Rectangle Path 1', mn: 'ADBE Vector Shape - Rect', hd: false,
    }, {
      ty: 'st', c: { a: 0, k: [1, 1, 1, 1], ix: 3 }, o: { a: 0, k: 40, ix: 4 }, w: { a: 0, k: 4, ix: 5 }, lc: 1, lj: 1, ml: 4, bm: 0, nm: 'Stroke 1', mn: 'ADBE Vector Graphic - Stroke', hd: false,
    }],
    ip: 0,
    op: 30,
    st: 0,
    bm: 0,
  }, {
    ddd: 0,
    ind: 4,
    ty: 3,
    nm: 'scroll Outlines 2',
    sr: 1,
    ks: {
      o: { a: 0, k: 100, ix: 11 },
      r: { a: 0, k: 0, ix: 10 },
      p: {
        a: 1,
        k: [{
          i: { x: 0.667, y: 1 }, o: { x: 0.333, y: 0 }, t: 1, s: [25, 44.5, 0], to: [0, 5, 0], ti: [0, 0, 0],
        }, {
          i: { x: 0.145, y: 1 }, o: { x: 0.42, y: 0 }, t: 9, s: [25, 74.5, 0], to: [0, 0, 0], ti: [0, 5, 0],
        }, {
          i: { x: 0.833, y: 0.833 }, o: { x: 0.333, y: 0.333 }, t: 21, s: [25, 44.5, 0], to: [0, 0, 0], ti: [0, 0, 0],
        }, {
          i: { x: 0.667, y: 1 }, o: { x: 0.333, y: 0 }, t: 251, s: [25, 44.5, 0], to: [0, 5, 0], ti: [0, 0, 0],
        }, {
          i: { x: 0.667, y: 1 }, o: { x: 0.333, y: 0 }, t: 256, s: [25, 74.5, 0], to: [0, 0, 0], ti: [0, 5, 0],
        }, { t: 264, s: [25, 44.5, 0] }],
        ix: 2,
        l: 2,
      },
      a: {
        a: 0, k: [9, 13, 0], ix: 1, l: 2,
      },
      s: {
        a: 0, k: [200, 200, 100], ix: 6, l: 2,
      },
    },
    ao: 0,
    ef: [{
      ty: 5,
      nm: 'Transform',
      np: 14,
      mn: 'ADBE Geometry2',
      ix: 1,
      en: 1,
      ef: [{
        ty: 3, nm: 'Anchor Point', mn: 'ADBE Geometry2-0001', ix: 1, v: { a: 0, k: [25, 65.5], ix: 1 },
      }, {
        ty: 3, nm: 'Position', mn: 'ADBE Geometry2-0002', ix: 2, v: { a: 0, k: [25, 65.5], ix: 2 },
      }, {
        ty: 7, nm: 'Uniform Scale', mn: 'ADBE Geometry2-0011', ix: 3, v: { a: 0, k: 1, ix: 3 },
      }, {
        ty: 0, nm: 'Scale', mn: 'ADBE Geometry2-0003', ix: 4, v: { a: 0, k: 100, ix: 4 },
      }, {
        ty: 0, nm: ' ', mn: 'ADBE Geometry2-0004', ix: 5, v: { a: 0, k: 100, ix: 5 },
      }, {
        ty: 0, nm: 'Skew', mn: 'ADBE Geometry2-0005', ix: 6, v: { a: 0, k: 0, ix: 6 },
      }, {
        ty: 0, nm: 'Skew Axis', mn: 'ADBE Geometry2-0006', ix: 7, v: { a: 0, k: 0, ix: 7 },
      }, {
        ty: 0, nm: 'Rotation', mn: 'ADBE Geometry2-0007', ix: 8, v: { a: 0, k: 0, ix: 8 },
      }, {
        ty: 0, nm: 'Opacity', mn: 'ADBE Geometry2-0008', ix: 9, v: { a: 0, k: 40, ix: 9 },
      }, {
        ty: 7, nm: 'Use Composition’s Shutter Angle', mn: 'ADBE Geometry2-0009', ix: 10, v: { a: 0, k: 1, ix: 10 },
      }, {
        ty: 0, nm: 'Shutter Angle', mn: 'ADBE Geometry2-0010', ix: 11, v: { a: 0, k: 0, ix: 11 },
      }, {
        ty: 7, nm: 'Sampling', mn: 'ADBE Geometry2-0012', ix: 12, v: { a: 0, k: 1, ix: 12 },
      }],
    }],
    ip: 0,
    op: 30,
    st: 1,
    bm: 0,
  }, {
    ddd: 0,
    ind: 5,
    ty: 4,
    nm: 'scroll Outlines',
    sr: 1,
    ks: {
      o: { a: 0, k: 100, ix: 11 },
      r: { a: 0, k: 0, ix: 10 },
      p: {
        a: 1,
        k: [{
          i: { x: 0.667, y: 1 }, o: { x: 0.333, y: 0 }, t: 0, s: [25, 105.5, 0], to: [0, 2.5, 0], ti: [0, 0, 0],
        }, {
          i: { x: 0.145, y: 1 }, o: { x: 0.42, y: 0 }, t: 8, s: [25, 120.5, 0], to: [0, 0, 0], ti: [0, 2.5, 0],
        }, {
          i: { x: 0.667, y: 0.667 }, o: { x: 0.333, y: 0.333 }, t: 20, s: [25, 105.5, 0], to: [0, 0, 0], ti: [0, 0, 0],
        }, {
          i: { x: 0.667, y: 1 }, o: { x: 0.333, y: 0 }, t: 250, s: [25, 105.5, 0], to: [0, 2.5, 0], ti: [0, 0, 0],
        }, {
          i: { x: 0.667, y: 1 }, o: { x: 0.333, y: 0 }, t: 255, s: [25, 120.5, 0], to: [0, 0, 0], ti: [0, 2.5, 0],
        }, { t: 263, s: [25, 105.5, 0] }],
        ix: 2,
        l: 2,
      },
      a: {
        a: 0, k: [9, 43.5, 0], ix: 1, l: 2,
      },
      s: {
        a: 0, k: [200, 200, 100], ix: 6, l: 2,
      },
    },
    ao: 0,
    shapes: [{
      ty: 'gr',
      it: [{
        ind: 0,
        ty: 'sh',
        ix: 1,
        ks: {
          a: 0,
          k: {
            i: [[0, 0], [0, 0], [-0.475, 0.285]], o: [[0, 0], [0.475, 0.285], [0, 0]], v: [[0, 1.571], [-0.772, 2.857], [0.772, 2.857]], c: true,
          },
          ix: 2,
        },
        nm: 'Path 1',
        mn: 'ADBE Vector Shape - Group',
        hd: false,
      }, {
        ind: 1,
        ty: 'sh',
        ix: 2,
        ks: {
          a: 0,
          k: {
            i: [[0, 0], [0.426, 0.71], [0.71, -0.426]], o: [[0.71, -0.426], [-0.426, -0.71], [0, 0]], v: [[5.772, -0.143], [6.286, -2.201], [4.228, -2.716]], c: true,
          },
          ix: 2,
        },
        nm: 'Path 2',
        mn: 'ADBE Vector Shape - Group',
        hd: false,
      }, {
        ind: 2,
        ty: 'sh',
        ix: 3,
        ks: {
          a: 0,
          k: {
            i: [[0, 0], [0.426, -0.71], [-0.71, -0.426]], o: [[-0.71, -0.426], [-0.426, 0.71], [0, 0]], v: [[-4.228, -2.716], [-6.286, -2.201], [-5.772, -0.143]], c: true,
          },
          ix: 2,
        },
        nm: 'Path 3',
        mn: 'ADBE Vector Shape - Group',
        hd: false,
      }, {
        ind: 3,
        ty: 'sh',
        ix: 4,
        ks: {
          a: 0,
          k: {
            i: [[0, 0], [0, 0], [0, 0], [0, 0]], o: [[0, 0], [0, 0], [0, 0], [0, 0]], v: [[0.772, 2.857], [5.772, -0.143], [4.228, -2.716], [-0.772, 0.284]], c: true,
          },
          ix: 2,
        },
        nm: 'Path 4',
        mn: 'ADBE Vector Shape - Group',
        hd: false,
      }, {
        ind: 4,
        ty: 'sh',
        ix: 5,
        ks: {
          a: 0,
          k: {
            i: [[0, 0], [0, 0], [0, 0], [0, 0]], o: [[0, 0], [0, 0], [0, 0], [0, 0]], v: [[0.772, 0.284], [-4.228, -2.716], [-5.772, -0.143], [-0.772, 2.857]], c: true,
          },
          ix: 2,
        },
        nm: 'Path 5',
        mn: 'ADBE Vector Shape - Group',
        hd: false,
      }, {
        ty: 'mm', mm: 1, nm: 'Merge Paths 1', mn: 'ADBE Vector Filter - Merge', hd: false,
      }, {
        ty: 'fl', c: { a: 0, k: [1, 1, 1, 1], ix: 4 }, o: { a: 0, k: 100, ix: 5 }, r: 1, bm: 0, nm: 'Fill 1', mn: 'ADBE Vector Graphic - Fill', hd: false,
      }, {
        ty: 'tr', p: { a: 0, k: [9, 43.429], ix: 2 }, a: { a: 0, k: [0, 0], ix: 1 }, s: { a: 0, k: [100, 100], ix: 3 }, r: { a: 0, k: 0, ix: 6 }, o: { a: 0, k: 100, ix: 7 }, sk: { a: 0, k: 0, ix: 4 }, sa: { a: 0, k: 0, ix: 5 }, nm: 'Transform',
      }],
      nm: 'Group 3',
      np: 7,
      cix: 2,
      bm: 0,
      ix: 1,
      mn: 'ADBE Vector Group',
      hd: false,
    }],
    ip: 0,
    op: 30,
    st: 0,
    bm: 0,
  }],
  markers: [{ tm: 250, cm: '1', dr: 0 }],
};
